import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const SORT_KEY = 'sort';

const useSorting = (): {
  sortBy: string | null;
  setSortBy (s: string | null): void;
} => {
  const location = useLocation();
  const history = useHistory();

  // default comes from QS.

  const [internalSortBy, setInternalSortBy] = useState<string | null>(null);

  // when the query params change, we need to update the sortByState
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sortByQueryParam = params.get(SORT_KEY);

    setInternalSortBy(sortByQueryParam);
  }, [location.search]);

  const setSortBy = (sortDirection: string) => {
    const params = new URLSearchParams(location.search);

    if (sortDirection) {
      params.set(SORT_KEY, sortDirection);
    } else {
      params.delete(SORT_KEY);
    }

    history.replace({ search: params.toString() });
  };

  return {
    sortBy: internalSortBy,
    setSortBy,
  };
};

export default useSorting;
